import { useReducedMotion } from "framer-motion";

const petals = [
  { left: "62%", size: 20, dur: 16, delay: 0, rot: 20 },
  { left: "74%", size: 16, dur: 19, delay: 3, rot: -30 },
  { left: "84%", size: 18, dur: 17, delay: 6, rot: 45 },
  { left: "91%", size: 15, dur: 21, delay: 1.5, rot: -10 },
  { left: "50%", size: 17, dur: 23, delay: 4.5, rot: 60 },
  { left: "79%", size: 19, dur: 18, delay: 8, rot: -45 },
  { left: "40%", size: 14, dur: 22, delay: 7, rot: 15 },
  { left: "88%", size: 16, dur: 20, delay: 10, rot: 35 },
];

export const FallingPetals = () => {
  const still = useReducedMotion();
  if (still) return null;
  return (
    <div className="pointer-events-none absolute inset-x-0 top-0 h-[88vh] overflow-hidden" aria-hidden="true" data-testid="falling-petals">
      {petals.map((p, i) => (
        <span
          key={i}
          className="petal-fall absolute -top-6"
          style={{ left: p.left, animationDuration: `${p.dur}s`, animationDelay: `${p.delay}s` }}
        >
          <svg
            viewBox="0 0 20 20"
            width={p.size}
            height={p.size}
            className="petal-sway block"
            style={{ animationDuration: `${p.dur / 4}s`, rotate: `${p.rot}deg` }}
          >
            <path d="M10 1C14 5 17 9 14 15c-1.5 3-6.5 3-8 0C3 9 6 5 10 1z" fill="#E3A3AE" fillOpacity="0.95" />
            <path d="M10 4v10" stroke="#D4919C" strokeOpacity="0.5" strokeWidth="0.8" />
          </svg>
        </span>
      ))}
    </div>
  );
};
